import {Injectable} from '@angular/core';

@Injectable()
export class importHelper {
    moduleDetails = [
        {"router": "/create-purchase-order", "path": "CreatePo.module", "module": "CreatePoModule", "provider": "createpo", "heading": "Create PO"},
        {"router": "/create-seal", "path": "CreateSeal.module", "module": "CreatesealModule", "provider": "createSeall", "heading": "Create Seal"},
        {"router": "/exporter-list", "path": "ExporterList.module", "module": "ExporterListModule", "provider": "explist", "heading": "Exporter List"},
        {"router": "/exporter-master", "path": "ExporterMaster.module", "module": "ExporterMasterModule", "provider": "expmaster", "heading": "Exporter Master"},
        {"router": "/create-importpurchase-order", "path": "ImpPurchaseOrderDetail.module", "module": "ImportPurchaseOrderDetailModule", "provider": "imppodetail", "heading": "Import PO Detail"},
        {"router": "/view-importpurchase-order", "path": "ImpPurchaseOrderList.module", "module": "ImportPurchaseOrderListingModule", "provider": "imppolist", "heading": "Import PO List"},
        {"router": "/viewdetails", "path": "ViewDetail.module", "module": "ViewDetailModule", "provider": "viewdetail", "heading": "Seal List"},
        {"router": "/view-purchase-order", "path": "ViewPo.module", "module": "ViewPoModule", "provider": "viewpo", "heading": "PO List"},
         {"router": "/reader-screen", "path": "Reader.module", "module": "ReaderScreenModule", "provider": "reader", "heading": "Reader"},
            {"router": "/create-payment", "path": "Payment.module", "module": "PaymentModule", "provider": "createPayment", "heading": "Payment List"},
         {"router": "/create-purchase", "path": "Purchase.module", "module": "PurchaseModule", "provider": "createPurchase", "heading": "Purchase List"},
          {"router": "/sealSale-report", "path": "SealSaleReport.module", "module": "SealsaleReportModule", "provider": "sealSale", "heading": "Seal Sale Report"},
           {"router": "/sealLock-report", "path": "SealLockReport.module", "module": "SeallockReportModule", "provider": "sealLock", "heading": "Seal Lock Report"},
            {"router": "/sealScan-report", "path": "SealScanReport.module", "module": "SealscanReportModule", "provider": "sealScan", "heading": "Seal Scan Report"},
        //  {"router": "/home", "path": "Home.module", "module": "HomeModule", "provider": "homedetail", "heading": " "}


    ];

    constrcutor() {
        this.moduleList();
    }
    moduleList() {
        // this.moduleDetails = ;
    }

}






// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/components/Multitab/importHelper.ts